<template>
  <container
      subHeaderTitle="정보유출안심케어<br /><b>해지하기</b>"
      subHeaderText="휴대폰으로 전송된 인증번호를 입력해주세요."
      subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>인증번호</p>
              <div class="d-flex">
                <v-text-field
                    ref="certNum"
                    label="인증번호 입력"
                    mask="#####"
                    :rules="rules.certNumRules"
                    v-model="certNum"
                    :suffix="countdown"
                    required
                    solo
                />
                <v-btn large depressed class="ml-2 resend" @click.stop="sendSmsCert"
                       :data-ga-category="gaEvent.category.support.prime.cert.name" :data-ga-label="gaEvent.category.support.prime.cert.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >재전송</v-btn>
              </div>
              <div class="pl-5 mt-2 mb-12">
                <ul>
                  <li>인증번호는 5분 이내에 입력하셔야 합니다.</li>
                  <li>인증시간이 초과하면 재전송하여 인증하시기 바랍니다.</li>
                </ul>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                       :data-ga-category="gaEvent.category.support.prime.cert.name" :data-ga-label="gaEvent.category.support.prime.cert.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >확인</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                       :data-ga-category="gaEvent.category.support.prime.cert.name" :data-ga-label="gaEvent.category.support.prime.cert.label3" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- 인증번호 인증 실패 -->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증번호가 일치하지 않습니다.<br />전송된 인증번호를 확인해보세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="dialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 처리 프로그레스 -->
    <v-dialog v-model="progressDialog" persistent max-width="100">
      <v-card>
        <v-progress-linear color="primary" indeterminate></v-progress-linear>
      </v-card>
    </v-dialog>

    <!-- 처리결과 다이얼로그 -->
    <v-dialog v-model="resultDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적으로 처리되지 않았습니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="resultDialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 시간제한 지났을때 -->
    <v-dialog v-model="countDownOverDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>인증시간이 초과했습니다.<br />인증번호를 재전송하여 인증해주세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="countDownOverDialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 점검 중 -->
    <v-dialog v-model="inspectionDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>서비스가 점검 중이에요.<br />나중에 다시 시도해주세요.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="inspectionDialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 계정 없음 -->
    <v-dialog v-model="notFoundDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>계정이 없습니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="notFoundDialog = false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "~@/styles/cscenter";

.v-messages__message {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
</style>

<script>
import Container from "@/pages/container/index.vue";
import { GaTracking, generateSHA256Hash, formater } from "@/mixins/index.js";

export default {
  mixins: [GaTracking, generateSHA256Hash, formater],
  name: "SafeidCert",
  components: {
    Container
  },
  data: ()  => ({
    valid: false,
    teleCoCd: "",
    teleCoNm: "",
    cellTelNo: "",
    certNum: "",
    dialog: false,
    progressDialog: false,
    resultDialog : false,
    returnDialog : false,
    countDownOverDialog: false,
    inspectionDialog: false,
    notFoundDialog: false,
    rules: {
      requiredCertNum: value => !!value || "인증번호를 입력하세요.",
      certNumRules: [
        v => !!v || "인증번호를 입력하세요.",
        v =>
            (v &&
                v.length >= 5 &&
                /([0-9]{5})$/.test(v)) ||
            "인증번호가 정확하지 않습니다."
      ],
      certNumLgTRules: [
        v => !!v || "인증번호를 입력하세요.",
        v =>
            (v &&
                (v.length >= 8 ||v.length == 5) &&
                /([0-9]{5})|([0-9]{8})$/.test(v)) ||
            "인증번호가 정확하지 않습니다."
      ]
    },
    //timer
    countdown: "5:00",
    endTime: "",
    hours: "",
    mins: "",
    msLeft: "",
    time: ""
  }),
  methods: {
    sendSmsCert(e) {

      if(e !== undefined && e != null) {
        this.gaTracking(e);
      }

      if(this.teleCoCd === "1") {
        this.teleCoNm = "skt";
      } else if(this.teleCoCd === "2") {
        this.teleCoNm = "kt";
      } else if(this.teleCoCd === "3") {
        this.teleCoNm = "lgu";
      }

      this.axios
          .post("/api/v1/external/hp/unregister/otp", {
            mediaType: this.teleCoNm,
            phoneNumber: this.cellTelNo,
          }, {
            baseURL: process.env.VUE_APP_SAFEID_API,
          })
          .then(result => {
            this.posts = result.data;
            this.countdowns("countdown", 5, 0);
          })
          .catch(err => {
            if (err.response.data.code === 'INSPECTION_ERROR') {
              this.inspectionDialog = true;
            }else {
              this.resultDialog = true;
            }
          });
    },
    countdowns(elementName, minutes, seconds) {
      this.minutes = minutes;
      this.seconds = seconds;
      this.endTime =
          +new Date() + 1000 * (60 * this.minutes + this.seconds) + 500;
      this.updateTimer();
    },
    updateTimer() {
      this.msLeft = this.endTime - +new Date();
      if (this.msLeft < 1000) {
        this.countdown = "0:00";
      } else {
        this.time = new Date(this.msLeft);
        this.hours = this.time.getUTCHours();
        this.mins = this.time.getUTCMinutes();
        this.countdown =
            (this.hours
                ? this.hours + ":" + this.twoDigits(this.mins)
                : this.mins) +
            ":" +
            this.twoDigits(this.time.getUTCSeconds());
        setTimeout(this.updateTimer, this.time.getUTCMilliseconds() + 500);
      }
    },
    twoDigits(n) {
      return n <= 9 ? "0" + n : n;
    },
    submit(e) {
      this.gaTracking(e);
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      this.progressDialog = true;

      if (this.countdown === "0:00") {
        this.progressDialog = false;
        this.countDownOverDialog = true;
        return false;
      }

      // 해지
      this.axios
          .post("/api/v1/external/hp/unregister",{
            mediaType: this.teleCoNm,
            phoneNumber: this.cellTelNo,
            otp: this.certNum,
          }, {
            baseURL: process.env.VUE_APP_SAFEID_API,
          })
          .then((result) => {
            this.progressDialog = false;
            this.$router.push({
              name: "SafeidResult",
              params: { type: "", result: "SUCCESS" }
            });
          })
          .catch((err) => {
            this.progressDialog = false;
            switch (err.response.data.code) {
              case 'INSPECTION_ERROR' :
                this.inspectionDialog = true;
                break;
              case 'EXIST_NOT_OTP_CAUSE_EXPIRED' :
                this.countDownOverDialog = true;
                break;
              case 'USERNAME_NOT_FOUND' :
                this.notFoundDialog = true;
                break;
              case 'OTP_NOT_MATCHED' :
                this.dialog = true;
                break;
              default :
                this.resultDialog = true;
            }
          });
    },
    goNext() {
      this.resultDialog = false;
      this.$router.push({ name: "SafeidResult", params: { type: "", result: "FAIL" } });
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.go(-1);
    }
  },
  created() {
    this.teleCoCd = this.$route.params.teleCoCd;
    this.cellTelNo = this.$route.params.cellTelNo;
  },
  mounted() {
    this.sendSmsCert(null);
  },
};
</script>